// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3OeCw","title":"Info_title__4QnjQ","selects":"Info_selects__1AnCW","requiredAsterisk":"Info_requiredAsterisk__2XDRo"};